module.exports = __webpack_public_path__ + "static/media/QSG_2022.d4bd5aa1.pdf";